import type { RouteObject } from 'react-router';

/** /privacidade and /termos: public on every host. */
export function legalRoutes(): RouteObject[] {
  return [
    {
      path: '/privacidade',
      lazy: async () => ({ Component: (await import('./PrivacyPolicyPage')).PrivacyPolicyPage }),
    },
    {
      path: '/termos',
      lazy: async () => ({ Component: (await import('./TermsPage')).TermsPage }),
    },
  ];
}
